module.exports = __webpack_public_path__ + "static/media/journal-style-06.17f0df32.svg";